import Link from "next/link";
import { Twitter, Linkedin, Github, Mail } from "lucide-react";

const COLS: { heading: string; links: { label: string; href: string; external?: boolean }[] }[] = [
  {
    heading: "Products",
    links: [
      { label: "Kuttos BMS", href: "/bms" },
      { label: "Kuttos AI", href: "/ai" },
      { label: "Mobile apps", href: "/mobile-apps" },
      { label: "Kuttos Store", href: "https://www.kuttostechnologies.com", external: true },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "Portfolio", href: "/portfolio" },
      { label: "Get started", href: "/auth/signup" },
      { label: "Support", href: "/support" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy policy", href: "/privacy" },
      { label: "Terms of service", href: "/terms" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer style={{ borderTop: "1px solid var(--st-line)", background: "var(--st-bg2)" }}>
      <div className="st-section" style={{ paddingTop: 44, paddingBottom: 28 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr 1fr 1fr", gap: 28 }} className="st-footer-grid">
          <div>
            <div style={{ marginBottom: 14 }}>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src="/images/kuttoslogo.png" alt="Kuttos Technologies" style={{ height: 30, width: "auto", display: "block" }} />
            </div>
            <p style={{ fontSize: 13, color: "var(--st-muted)", lineHeight: 1.6, maxWidth: 280, margin: 0 }}>
              The retail operating system — sell, stock, get paid and grow, across every branch, online and off.
            </p>
            <div style={{ display: "flex", gap: 9, marginTop: 16 }}>
              {[
                { Icon: Twitter, href: "#" },
                { Icon: Linkedin, href: "#" },
                { Icon: Github, href: "#" },
                { Icon: Mail, href: "mailto:hello@kuttostechnologies.com" },
              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  aria-label="Social link"
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: 9,
                    background: "var(--st-surface)",
                    border: "1px solid var(--st-line)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--st-muted)",
                  }}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.heading}>
              <div className="st-mono" style={{ fontSize: 10.5, color: "var(--st-faint)", marginBottom: 14 }}>{col.heading}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {col.links.map((l) =>
                  l.external ? (
                    <a key={l.label} href={l.href} className="st-link" style={{ fontSize: 13 }}>{l.label}</a>
                  ) : (
                    <Link key={l.label} href={l.href} className="st-link" style={{ fontSize: 13 }}>{l.label}</Link>
                  )
                )}
              </div>
            </div>
          ))}
        </div>

        <div
          style={{
            marginTop: 32,
            paddingTop: 20,
            borderTop: "1px solid var(--st-line)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <span style={{ fontSize: 12.5, color: "var(--st-faint)" }}>© 2026 Kuttos Technologies. All rights reserved.</span>
          <span style={{ fontSize: 12.5, color: "var(--st-faint)" }}>Built in Uganda 🇺🇬 for African retail.</span>
        </div>
      </div>

      <style>{`
        @media (max-width: 820px) {
          .kuttos-site .st-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 24px !important; }
        }
      `}</style>
    </footer>
  );
}
